import { useState, createContext, useContext } from "react";
import { useParams, useLocation } from "react-router";

export const PlatformLayoutContext = createContext();

export const PlatformLayoutContextProvider = ({ children }) => {
  const { accountType, companyName } = useParams();
  const location = useLocation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({});
  const [communicationCenterTab, setCommunicationCenterTab] = useState(null);

  const openCommunicationCenter = (tab) => setCommunicationCenterTab(tab);

  const findInitialViewMode = () => {
    if (location.pathname.startsWith("/simulation")) {
      return "simulation";
    }

    return "company";
  };

  const [viewMode, setViewMode] = useState(findInitialViewMode());
  const rootPath =
    viewMode === "company"
      ? `/platform/${accountType}`
      : `/simulation/${companyName}`;

  const [lastTransactionUpdate, setLastTransactionUpdate] = useState(null);

  const activateSnackbar = (props) => {
    setSnackbarProps(props);
    setSnackbarOpen(true);
    setTimeout(() => {
      setSnackbarOpen(false);
    }, 5000);
  };

  const triggerTransactionUpdateCountdown = () => {
    setLastTransactionUpdate(new Date());

    return activateSnackbar({
      message: "Transaction updates will appear in your accounting soon.",
      severity: "success"
    });
  };

  return (
    <PlatformLayoutContext.Provider
      value={{
        snackbarOpen,
        setSnackbarOpen,
        snackbarProps,
        activateSnackbar,
        communicationCenterTab,
        openCommunicationCenter,
        viewMode,
        setViewMode,
        lastTransactionUpdate,
        setLastTransactionUpdate,
        triggerTransactionUpdateCountdown,
        rootPath,
        isSimulation: viewMode === "simulation"
      }}
    >
      {children}
    </PlatformLayoutContext.Provider>
  );
};
const usePlatformLayoutContext = () => useContext(PlatformLayoutContext);
export default usePlatformLayoutContext;
